import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import QrScanComp from '@components/QrScanComp';
import { setNotification } from '@reducers/notification';
import { checkOpen, occupySeat } from '@reducers/checks';
import { setSeat, setCurrentPage, removePosition } from '@reducers/orders';
import { updateChecksAfterResponse } from '@reducers/storeChecks';
import { flowType } from '@utility/userInfo';
import { getObjectValue } from '@utility/utills';
import { APP_CONFIG, ERROR_MESSAGE } from '@constants';

const QRCode = props => {
  const isServerApp = flowType() === 'serverApp';
  const isCounter = getObjectValue(
    () => isServerApp && [1].includes(props.deviceInfo.deviceGroup.startMode),
    false
  );
  const isOrderPayMode = getObjectValue(
    () => [1].includes(props.deviceInfo.deviceGroup.startMode),
    false
  );
  const isDriveThru = getObjectValue(() => isServerApp && [3].includes(props.deviceInfo.deviceGroup.startMode), false);
 const isCallCenter = getObjectValue(() => isServerApp && [2].includes(props.deviceInfo.deviceGroup.startMode), false);


  const guestSeatList = [];

  //Methods

  const itemsFilter = array => {
    return array
      .filter(e => e.pending)
      .map(e => {
        return {
          ...e,
          ...JSON.parse(e.orderJson),
        };
      });
  };

  const guestSeats = (tableValue, val = 1) => {
    const obj = {
      number: val,
      tableShareType: 0,
    };
    guestSeatList.push(obj);
    return tableValue > val && guestSeats(tableValue, val + 1);
  };

  const submitSeatNumber = (value, tableValue) => {
    guestSeats(tableValue);
    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      storeId: props.deviceInfo.storeId,
      employeeCard: props.userInfo.employeeCard,
      seats: guestSeatList,
      checkHeaderId: value && value?.id,
    };
    props
      .occupySeat(dataToSend)
      .then(data => {
        props.setSeat({
          ...data,
          pendingItems: itemsFilter(data.orders[0] && data.orders[0].items),
        });
        props.removePosition();
        props.setCurrentPage(props.pageNo || 0);
        props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/orders` });
      })
      .catch(err => {
        props.setNotification({
          type: 'danger',
          message: err.message,
        });
      });
  };

  const onScanSuccess = sensorCode => {
    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      storeId: props.deviceInfo.storeId,
      stationId: null,
      name: null,
      stationGroupId: null,
      isTab: false,
      phoneNumber: null,
      pickupTime: null,
      guestName: null,
      guestCount: 1,
      sourceType: 0,
      delivery: false,
      employeeCard: props.userInfo.employeeCard,
      sensorCode,
      speedOrder: isCounter || isDriveThru || isCallCenter,
      orderPay: isOrderPayMode
    };
    props
      .checkOpen(dataToSend)
      .then(val => {
        props.updateChecksAfterResponse(val);
        if (val.seats && val.seats.length > 0) {
          props.setSeat({
            ...val,
            pendingItems: itemsFilter(val.orders[0] && val.orders[0].items),
          });
          props.removePosition();
          props.setCurrentPage(props.pageNo || 0);
          props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/orders` });
        } else {
          submitSeatNumber(val, 1);
        }
      })
      .catch(err => {
        props.setNotification({
          type: 'danger',
          message: err.message,
        });
      });
  };

  const onScanFailure = () => {
    props.setNotification({
      type: 'danger',
      message: ERROR_MESSAGE.SOMETHING_WENT_WRONG,
    });
  };
  const handleScan = data => {
    let sensorCode = '';
    if (data && !props.loading) {
      const guid = data.split('/');
      const code =
        `${guid[guid.length - 1]}`.indexOf('=') !== -1
          ? `${guid[guid.length - 1]}`.split('=')
          : guid;
      sensorCode = code[code.length - 1].replace('/', '');
      if (sensorCode) {
        onScanSuccess(sensorCode);
      } else {
        onScanFailure();
      }
    }
  };

  const handleError = () => {
    props.setNotification({
      type: 'danger',
      message: ERROR_MESSAGE.SOMETHING_WRONG,
    });
    props.history.push(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
  };

  const handleCancel = () => {
    props.history.push(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
  };

  // HTML CSS Code

  return (
    <div className="col-12 h-100 row mx-0 align-items-center">
      <QrScanComp
        handleScan={handleScan}
        handleError={handleError}
        handleCancel={handleCancel}
      />
    </div>
  );
};

//Redux Part

const mapStateToProps = state => ({
  loading:
    state.checks.loading || state.oauth.loading || state.storeChecks.loading,
  deviceInfo: state.oauth.deviceInformation,
  auth: state.oauth.authInfo,
  userInfo: state.oauth.loggedInUserData,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setNotification,
      checkOpen,
      occupySeat,
      setSeat,
      removePosition,
      setCurrentPage,
      updateChecksAfterResponse,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(QRCode);
